module.exports = __webpack_public_path__ + "img/map-marker-alt-solid.67b80c9a.svg";